import { CHANGE_LANGUAGE, CLOSE_FULL_SCREEN, CLOSE_WORKFLOW, OPEN_FULL_SCREEN, OPEN_WORKFLOW } from '../../constant';

const changeLanguageAction = (language) => ({
  type: CHANGE_LANGUAGE,
  language,
});

const openFullScreen = () => ({
  type: OPEN_FULL_SCREEN,
});

const closeFullScreen = () => ({
  type: CLOSE_FULL_SCREEN,
});

const openAdmissionWorkflow = () => ({
  type: OPEN_WORKFLOW,
});

const closeAdmissionWorkflow = () => ({
  type: CLOSE_WORKFLOW,
});

export { changeLanguageAction, openFullScreen, closeFullScreen, openAdmissionWorkflow, closeAdmissionWorkflow };
